// @flow

import type { ComponentType, Node } from 'react'
import React from 'react'

import styled from '@emotion/styled'
import { media, colors } from '@toggl/style'
import { Icon } from '@toggl/ui'
import * as text from '../text'

const icons = {
  track: <Icon.Track dark />,
  hire: <Icon.Hire dark />,
  plan: <Icon.Plan dark />,
}

export function Product({
  img,
  title,
  description,
}: {
  img: string | Node,
  title: Node | string,
  description: string,
}) {
  return (
    <StyledProduct>
      {typeof img === 'string' && <img src={img} alt={description} />}
      {typeof img !== 'string' && img}

      <Wrapper>
        <Title>
          {typeof title === 'string' &&
          ['track', 'plan', 'hire'].includes(title)
            ? icons[title]
            : title}
        </Title>
        <Description>{description}</Description>
      </Wrapper>
    </StyledProduct>
  )
}

const Title = styled.div`
  color: ${colors.darkPurple};
  svg {
    height: 28px;
    margin: 8px 0 5px;
  }
`

const Wrapper = styled.div`
  display: flex;
`

const Description = styled.div`
  ${text.paragraph4};
  color: ${colors.darkPurple};
  margin-top: 10px;
`

export const ProductsGroup: ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  a {
    color: ${colors.darkPurple};
    flex: 1;
    margin: 10px 0;
  }

  ${media.mq[1]} {
    flex-direction: row;
    a {
      margin: 10px;
      &:nth-child(1) {
        margin: 10px 10px 10px 0;
      }
      &:hover img {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
      }
    }
  }

  ${media.mq[2]} {
    a {
      padding-right: 20px;
      max-width: 300px;
    }
  }
`

const StyledProduct: ComponentType<any> = styled.div`
  display: flex;
  & > img {
    width: 40%;
    max-width: 140px;
    margin-right: 20px;
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    > div:last-child {
      margin-top: 0;
    }
  }

  ${media.mq[1]} {
    display: inline-block;
    width: 100%;

    & > img {
      width: 100%;
      max-width: none;
      margin-right: 0;
      padding: 8px;
      background: ${colors.almostWhite};
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
      transition: 0.5s ease;
    }

    & > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 0;
      margin-top: 16px;

      & > span {
        margin-top: 10px;
      }
    }
  }
`
